module.exports = __webpack_public_path__ + "static/img/pool.fbe62dee.png";